import store from '@store/index'

function UserGuard(to, from, next) {
  let user = store.getters['auth/user']
  if (!user) next({ name: 'login' })
  else if (user.role !== 'CardUser') next('/')
  else next()
}

export default UserGuard